import { Lock01 } from "@cvpartner/design-system/icons/line";
import type * as React from "react";
import { I18n } from "@/shared/util/translations.ts";
import { noAccessIcon } from "./Styles.css.ts";
import { Wrapper } from "./Wrapper.tsx";

export const Forbidden: React.FC<{ showHeader?: boolean }> = ({
  showHeader,
}) => (
  <Wrapper
    showHeader={showHeader}
    heading={I18n.t("no_access.heading")}
    description={I18n.t("no_access.description")}
    icon={<Lock01 className={noAccessIcon} aria-hidden={true} />}
  />
);
